import React from 'react'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

type Props = {
  title: string
  subTitle: string | React.ReactNode
  price: string
  remove?: (...args: Array<any>) => any
  isPhone?: boolean
}

const ChargebeeComponent = ({
  title,
  subTitle,
  remove,
  price,
  isPhone,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.chargebeeComponent}>
      <div>
        <h2 className={styles.chargebeeComponentTitle}>{title}</h2>
        <h3 className={styles.chargebeeComponentSubTitle}>
          <div>{subTitle}</div>
          {remove && (
            <Icon
              className={styles.chargebeeComponentRemoveIcon}
              type="cancel"
              onClick={remove}
              width={!isPhone ? 12 : 24}
              height={!isPhone ? 14 : 24}
            />
          )}
        </h3>
      </div>
      <div className={styles.chargebeeComponentPrice}>{price}</div>
    </div>
  )
}

export default ChargebeeComponent
